import { Dispatcher } from "@fanfanlo";
// import { projectStore } from "../storage";
import { projectStore } from "@droid/project-interface";
export class ProjectModel extends Dispatcher{

    constructor(){
        super();
    }

    async init(){
        projectStore.init()
    }
    



}

export const projectModel = new ProjectModel();
